import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { useCommonDataContext } from "@core/CommonDataContext";

const DataReflectLabel: FCX = ({ className }) => {
    const { periodLabel } = useCommonDataContext();

    return (
        <div
            className={
                cn("appears-right del-3", className)
            }
            data-testid="textDataReflectLabel"
        >
            <span>data as of {periodLabel}</span>
            <br/>
            <div className="appears-right del-6">reflects 2 year change</div>
        </div>
    );
};

export default DataReflectLabel;